module.exports = __webpack_public_path__ + "img/76139.3ddda8c9.svg";